import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Image,
} from "@chakra-ui/react";

// Shared full-size viewer for a clicked image or video — used by both the
// read-only ViewNewsModal and the editable NewsMediaManager galleries.
function MediaLightbox({ media, onClose }) {
  if (!media) return null;

  return (
    <Modal isOpen={true} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent bg="black" boxShadow="none">
        <ModalCloseButton color="white" zIndex={1} />
        <ModalBody p={0} display="flex" alignItems="center" justifyContent="center" minH="50vh">
          {media.type === "video" ? (
            <video
              src={media.src}
              controls
              autoPlay
              style={{ maxWidth: "100%", maxHeight: "85vh" }}
            />
          ) : (
            <Image src={media.src} alt={media.alt || ""} maxH="85vh" maxW="100%" objectFit="contain" />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default MediaLightbox;
